













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateFaqCategoryRequest from '@/models/FaqCategories/UpdateFaqCategoryRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'AgencyGroupEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new UpdateFaqCategoryRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new UpdateFaqCategoryRequest();
      const existingVal = JSON.parse(JSON.stringify(AgencySettingsModule.currentFaqCategory));
      this.entity.name = existingVal.name;
      this.entity.updatedAt = existingVal.updatedAt;
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await AgencySettingsModule.editFaqCategory(this.entity)
    this.dialog = false;
  }
}
